// extracted by mini-css-extract-plugin
export default {"form":"styles_form__06FG+","asterisk":"styles_asterisk__cz0aY"};